/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { accessProjectsMembersDestroy } from '../fn/access-members/access-projects-members-destroy';
import { AccessProjectsMembersDestroy$Params } from '../fn/access-members/access-projects-members-destroy';
import { accessProjectsMembersInviteCreate } from '../fn/access-members/access-projects-members-invite-create';
import { accessProjectsMembersInviteCreate$FormData } from '../fn/access-members/access-projects-members-invite-create-form-data';
import { AccessProjectsMembersInviteCreate$FormData$Params } from '../fn/access-members/access-projects-members-invite-create-form-data';
import { AccessProjectsMembersInviteCreate$Params } from '../fn/access-members/access-projects-members-invite-create';
import { accessProjectsMembersInviteCreate$XWwwFormUrlencoded } from '../fn/access-members/access-projects-members-invite-create-x-www-form-urlencoded';
import { AccessProjectsMembersInviteCreate$XWwwFormUrlencoded$Params } from '../fn/access-members/access-projects-members-invite-create-x-www-form-urlencoded';
import { accessProjectsMembersList } from '../fn/access-members/access-projects-members-list';
import { AccessProjectsMembersList$Params } from '../fn/access-members/access-projects-members-list';
import { accessProjectsMembersOtherProjectsList } from '../fn/access-members/access-projects-members-other-projects-list';
import { AccessProjectsMembersOtherProjectsList$Params } from '../fn/access-members/access-projects-members-other-projects-list';
import { accessProjectsMembersPartialUpdate } from '../fn/access-members/access-projects-members-partial-update';
import { AccessProjectsMembersPartialUpdate$Params } from '../fn/access-members/access-projects-members-partial-update';
import { accessProjectsMembersPermissionsRetrieve } from '../fn/access-members/access-projects-members-permissions-retrieve';
import { AccessProjectsMembersPermissionsRetrieve$Params } from '../fn/access-members/access-projects-members-permissions-retrieve';
import { accessProjectsMembersPermissionsUpdate } from '../fn/access-members/access-projects-members-permissions-update';
import { AccessProjectsMembersPermissionsUpdate$Params } from '../fn/access-members/access-projects-members-permissions-update';
import { accessProjectsMyPermissionsRetrieve } from '../fn/access-members/access-projects-my-permissions-retrieve';
import { AccessProjectsMyPermissionsRetrieve$Params } from '../fn/access-members/access-projects-my-permissions-retrieve';
import { BackendMemberDto } from '../models/backend-member-dto';
import { BackendMemberInviteDto } from '../models/backend-member-invite-dto';
import { BackendOtherProjectMembershipDto } from '../models/backend-other-project-membership-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiAccessMembersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accessProjectsMembersList()` */
  static readonly AccessProjectsMembersListPath = '/api/access/projects/{project_id}/members/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMembersList()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersList$Response(
    params: AccessProjectsMembersList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendMemberDto>>> {
    return accessProjectsMembersList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMembersList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersList(
    params: AccessProjectsMembersList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendMemberDto>> {
    return this.accessProjectsMembersList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendMemberDto>>): Array<BackendMemberDto> => r.body),
    );
  }

  /** Path part for operation `accessProjectsMembersDestroy()` */
  static readonly AccessProjectsMembersDestroyPath = '/api/access/projects/{project_id}/members/{mid}/';

  /**
   * Удалить участника.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMembersDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersDestroy$Response(
    params: AccessProjectsMembersDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accessProjectsMembersDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Удалить участника.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMembersDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersDestroy(params: AccessProjectsMembersDestroy$Params, context?: HttpContext): Observable<void> {
    return this.accessProjectsMembersDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `accessProjectsMembersPartialUpdate()` */
  static readonly AccessProjectsMembersPartialUpdatePath = '/api/access/projects/{project_id}/members/{mid}/';

  /**
   * Изменить роль/статус/пресет участника.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMembersPartialUpdate()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersPartialUpdate$Response(
    params: AccessProjectsMembersPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMemberDto>> {
    return accessProjectsMembersPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Изменить роль/статус/пресет участника.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMembersPartialUpdate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersPartialUpdate(
    params: AccessProjectsMembersPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendMemberDto> {
    return this.accessProjectsMembersPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMemberDto>): BackendMemberDto => r.body),
    );
  }

  /** Path part for operation `accessProjectsMembersOtherProjectsList()` */
  static readonly AccessProjectsMembersOtherProjectsListPath =
    '/api/access/projects/{project_id}/members/{mid}/other-projects/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMembersOtherProjectsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersOtherProjectsList$Response(
    params: AccessProjectsMembersOtherProjectsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendOtherProjectMembershipDto>>> {
    return accessProjectsMembersOtherProjectsList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMembersOtherProjectsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersOtherProjectsList(
    params: AccessProjectsMembersOtherProjectsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendOtherProjectMembershipDto>> {
    return this.accessProjectsMembersOtherProjectsList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<Array<BackendOtherProjectMembershipDto>>): Array<BackendOtherProjectMembershipDto> =>
          r.body,
      ),
    );
  }

  /** Path part for operation `accessProjectsMembersPermissionsRetrieve()` */
  static readonly AccessProjectsMembersPermissionsRetrievePath =
    '/api/access/projects/{project_id}/members/{mid}/permissions/';

  /**
   * Получить эффективную матрицу прав участника.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMembersPermissionsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersPermissionsRetrieve$Response(
    params: AccessProjectsMembersPermissionsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accessProjectsMembersPermissionsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Получить эффективную матрицу прав участника.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMembersPermissionsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersPermissionsRetrieve(
    params: AccessProjectsMembersPermissionsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.accessProjectsMembersPermissionsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `accessProjectsMembersPermissionsUpdate()` */
  static readonly AccessProjectsMembersPermissionsUpdatePath =
    '/api/access/projects/{project_id}/members/{mid}/permissions/';

  /**
   * Задать override прав (только для guest).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMembersPermissionsUpdate()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersPermissionsUpdate$Response(
    params: AccessProjectsMembersPermissionsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accessProjectsMembersPermissionsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Задать override прав (только для guest).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMembersPermissionsUpdate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMembersPermissionsUpdate(
    params: AccessProjectsMembersPermissionsUpdate$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.accessProjectsMembersPermissionsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `accessProjectsMembersInviteCreate()` */
  static readonly AccessProjectsMembersInviteCreatePath = '/api/access/projects/{project_id}/members/invite/';

  /**
   * B6: email-флоу. Создаём ProjectInvitation (pending) + отправляем письмо.
   *
   * Если у пользователя с этим email уже есть membership → 409.
   * Если на email уже есть pending invitation → 409 (используйте /resend/).
   * Если на email есть accepted invitation → 409 (он уже принял в прошлом).
   * Если на email есть expired/revoked invitation → реюз существующей строки
   * (новый токен/срок/статус=pending).
   *
   * Тарифный лимит `projects_invite_limit` считается как members + pending.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMembersInviteCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accessProjectsMembersInviteCreate$Response(
    params: AccessProjectsMembersInviteCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMemberInviteDto>> {
    return accessProjectsMembersInviteCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * B6: email-флоу. Создаём ProjectInvitation (pending) + отправляем письмо.
   *
   * Если у пользователя с этим email уже есть membership → 409.
   * Если на email уже есть pending invitation → 409 (используйте /resend/).
   * Если на email есть accepted invitation → 409 (он уже принял в прошлом).
   * Если на email есть expired/revoked invitation → реюз существующей строки
   * (новый токен/срок/статус=pending).
   *
   * Тарифный лимит `projects_invite_limit` считается как members + pending.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMembersInviteCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accessProjectsMembersInviteCreate(
    params: AccessProjectsMembersInviteCreate$Params,
    context?: HttpContext,
  ): Observable<BackendMemberInviteDto> {
    return this.accessProjectsMembersInviteCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMemberInviteDto>): BackendMemberInviteDto => r.body),
    );
  }

  /**
   * B6: email-флоу. Создаём ProjectInvitation (pending) + отправляем письмо.
   *
   * Если у пользователя с этим email уже есть membership → 409.
   * Если на email уже есть pending invitation → 409 (используйте /resend/).
   * Если на email есть accepted invitation → 409 (он уже принял в прошлом).
   * Если на email есть expired/revoked invitation → реюз существующей строки
   * (новый токен/срок/статус=pending).
   *
   * Тарифный лимит `projects_invite_limit` считается как members + pending.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMembersInviteCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accessProjectsMembersInviteCreate$XWwwFormUrlencoded$Response(
    params: AccessProjectsMembersInviteCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMemberInviteDto>> {
    return accessProjectsMembersInviteCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * B6: email-флоу. Создаём ProjectInvitation (pending) + отправляем письмо.
   *
   * Если у пользователя с этим email уже есть membership → 409.
   * Если на email уже есть pending invitation → 409 (используйте /resend/).
   * Если на email есть accepted invitation → 409 (он уже принял в прошлом).
   * Если на email есть expired/revoked invitation → реюз существующей строки
   * (новый токен/срок/статус=pending).
   *
   * Тарифный лимит `projects_invite_limit` считается как members + pending.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMembersInviteCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accessProjectsMembersInviteCreate$XWwwFormUrlencoded(
    params: AccessProjectsMembersInviteCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendMemberInviteDto> {
    return this.accessProjectsMembersInviteCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMemberInviteDto>): BackendMemberInviteDto => r.body),
    );
  }

  /**
   * B6: email-флоу. Создаём ProjectInvitation (pending) + отправляем письмо.
   *
   * Если у пользователя с этим email уже есть membership → 409.
   * Если на email уже есть pending invitation → 409 (используйте /resend/).
   * Если на email есть accepted invitation → 409 (он уже принял в прошлом).
   * Если на email есть expired/revoked invitation → реюз существующей строки
   * (новый токен/срок/статус=pending).
   *
   * Тарифный лимит `projects_invite_limit` считается как members + pending.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMembersInviteCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accessProjectsMembersInviteCreate$FormData$Response(
    params: AccessProjectsMembersInviteCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendMemberInviteDto>> {
    return accessProjectsMembersInviteCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * B6: email-флоу. Создаём ProjectInvitation (pending) + отправляем письмо.
   *
   * Если у пользователя с этим email уже есть membership → 409.
   * Если на email уже есть pending invitation → 409 (используйте /resend/).
   * Если на email есть accepted invitation → 409 (он уже принял в прошлом).
   * Если на email есть expired/revoked invitation → реюз существующей строки
   * (новый токен/срок/статус=pending).
   *
   * Тарифный лимит `projects_invite_limit` считается как members + pending.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMembersInviteCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accessProjectsMembersInviteCreate$FormData(
    params: AccessProjectsMembersInviteCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendMemberInviteDto> {
    return this.accessProjectsMembersInviteCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendMemberInviteDto>): BackendMemberInviteDto => r.body),
    );
  }

  /** Path part for operation `accessProjectsMyPermissionsRetrieve()` */
  static readonly AccessProjectsMyPermissionsRetrievePath = '/api/access/projects/{project_id}/my-permissions/';

  /**
   * Эффективная матрица текущего пользователя.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accessProjectsMyPermissionsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMyPermissionsRetrieve$Response(
    params: AccessProjectsMyPermissionsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accessProjectsMyPermissionsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Эффективная матрица текущего пользователя.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accessProjectsMyPermissionsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accessProjectsMyPermissionsRetrieve(
    params: AccessProjectsMyPermissionsRetrieve$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.accessProjectsMyPermissionsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
